/* MRD Infinite Scroll | Theme-only; leaves Shopify's native paginated URLs intact. */
(function () {
  'use strict';

  var ROOT = '[data-mrd-infinite-collection]';
  var GRID = '[data-mrd-infinite-grid]';
  var PAGINATION = '[data-mrd-infinite-pagination]';
  var MAX_RESTORE_PAGES = 30;

  function init(root) {
    if (!root || root.dataset.mrdInfiniteBound === '1') return;
    var grid = root.querySelector(GRID);
    var pagination = root.querySelector(PAGINATION);
    var status = root.querySelector('[data-mrd-infinite-status]');
    var sentinel = root.querySelector('[data-mrd-infinite-sentinel]');
    if (!grid || !pagination || !status || !sentinel ||
        !window.fetch || !window.IntersectionObserver || !window.DOMParser) return;

    // Do not compete with an app if it has taken ownership of the collection grid.
    if (grid.querySelector('.snize-product, [data-searchanise-product]')) return;

    var nextUrl = null;
    var requestedUrls = new Set();
    var seenProducts = new Set();
    var busy = false;
    var restoring = false;
    var finished = false;
    var loadedPages = 0;
    var productNavigation = false;
    var storageKey = 'mrd-infinite-scroll:v1:' + location.pathname + location.search;

    function validPageUrl(href) {
      if (!href) return null;
      try {
        var candidate = new URL(href, location.href);
        var current = new URL(location.href);
        if (candidate.origin !== current.origin ||
            candidate.pathname.replace(/\/$/, '') !== current.pathname.replace(/\/$/, '') ||
            !candidate.searchParams.has('page')) return null;

        // Shopify's link is authoritative. Preserve preview/filter/sort parameters
        // if a theme or app omitted them from pagination links.
        current.searchParams.forEach(function (value, key) {
          if (key !== 'page' && !candidate.searchParams.has(key)) {
            candidate.searchParams.append(key, value);
          }
        });
        return candidate.href;
      } catch (error) {
        return null;
      }
    }

    function findNext(container) {
      if (!container) return null;
      var anchor = container.querySelector('a[rel="next"], .next a[href]');
      return validPageUrl(anchor && anchor.getAttribute('href'));
    }

    nextUrl = findNext(pagination);
    if (!nextUrl) return; // Empty/single-page collections keep normal theme behavior.

    Array.prototype.forEach.call(grid.querySelectorAll('[data-mrd-product-id]'), function (item) {
      if (item.dataset.mrdProductId) seenProducts.add(item.dataset.mrdProductId);
    });

    root.dataset.mrdInfiniteBound = '1';
    root.setAttribute('data-mrd-infinite-ready', '');
    var message = status.querySelector('.mrd-infinite-message');

    function setLoading(active) {
      status.classList.toggle('is-loading', active);
      root.setAttribute('aria-busy', active ? 'true' : 'false');
    }

    function fallback(messageText) {
      finished = true;
      observer.disconnect();
      root.removeAttribute('data-mrd-infinite-ready');
      status.classList.add('is-error');
      if (message) message.textContent = messageText || 'Unable to load more products. Use the page links below.';
    }

    function complete() {
      finished = true;
      observer.disconnect();
      status.classList.remove('is-error');
      root.removeAttribute('aria-busy');
    }

    function initializeNewCards(cards) {
      if (!cards.length) return;
      if (window.jQuery) {
        var $ = window.jQuery;
        cards.forEach(function (card) {
          // Venue binds swatches to existing cards at DOM-ready. Bind only new cards.
          $(card).find('.product__swatch__item').on('click.mrdInfinite', function (event) {
            event.preventDefault();
            var product = $(this).closest('.js-product');
            var image = product.find('.product__img');
            var variantImage = $(this).data('variant-image');
            var variantUrl = $(this).data('variant-url');
            if (variantImage) image.attr('data-src', variantImage).addClass('lazyload');
            if (variantUrl) product.find('.js-product-link').attr('href', variantUrl);
            product.find('.js-product-swatch-item').removeClass('js-active');
            $(this).addClass('js-active');
          });
          // Do NOT call theme.runAjaxCart(): it rebinds old forms, causing duplicate orders.
          if (root.dataset.mrdAjaxCart === 'true') {
            $(card).find('form.js-product-form').on('submit.mrdInfinite', function (event) {
              if (!window.ShopifyAPI || !window.ShopifyAPI.addItemFromForm ||
                  !window.ajaxCart || !window.ajaxCart.load) return;
              event.preventDefault();
              var form = this;
              var button = $(form).find('.js-product-add');
              if (button.hasClass('is-adding')) return;
              button.removeClass('is-added').addClass('is-adding');
              window.ShopifyAPI.addItemFromForm(form, function () {
                button.removeClass('is-adding').addClass('is-added');
                window.ajaxCart.load();
              }, function (xhr) {
                button.removeClass('is-adding is-added');
                var text = 'This product could not be added to your cart.';
                try { text = JSON.parse(xhr.responseText).description || text; } catch (_) {}
                $(form).find('.mrd-infinite-cart-error').remove();
                $('<div class="errors qty-error mrd-infinite-cart-error" role="alert"></div>').text(text).insertAfter(form);
              });
            });
          }
        });
        var $grid = $(grid);
        if ($grid.hasClass('o-layout--masonry') && $.fn.masonry) {
          if ($grid.data('masonry')) {
            $grid.masonry('appended', cards).masonry('layout');
            if ($.fn.imagesLoaded) $(cards).imagesLoaded(function () { $grid.masonry('layout'); });
          } else if (window.theme && typeof window.theme.masonryLayout === 'function') {
            window.theme.masonryLayout();
          }
        }
      }

      // Lazysizes and ScrollReveal are existing Venue features, not extra libraries.
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      if (window.sr && document.body.dataset.animLoad === 'true' &&
          typeof window.sr.sync === 'function') window.sr.sync();
      if (window.theme && typeof window.theme.convertCurrecny === 'function') {
        window.theme.convertCurrecny();
      }
      document.dispatchEvent(new CustomEvent('mrd:infinite-products-appended', {
        detail: { count: cards.length }
      }));
    }

    async function loadNext() {
      if (busy || finished || !nextUrl) return false;
      var targetUrl = nextUrl;
      if (requestedUrls.has(targetUrl)) { complete(); return false; }
      busy = true;
      requestedUrls.add(targetUrl);
      setLoading(true);
      try {
        // Shopify Section Rendering API: fetch only the collection section,
        // not the whole page, to minimize transferred markup on every load.
        var sectionUrl = new URL(targetUrl);
        sectionUrl.searchParams.set('section_id', root.getAttribute('data-section-id') || 'collection-template');
        var response = await fetch(sectionUrl.href, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        var doc = new DOMParser().parseFromString(response.ok ? await response.text() : '', 'text/html');
        var incomingRoot = doc.querySelector(ROOT);
        if (!incomingRoot) {
          // Section rendering may be intercepted by third-party apps; use the
          // normal crawlable pagination URL as a one-time compatibility fallback.
          response = await fetch(targetUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) throw new Error('Pagination response: ' + response.status);
          doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          incomingRoot = doc.querySelector(ROOT);
        }
        var incomingGrid = incomingRoot && incomingRoot.querySelector(GRID);
        var incomingPagination = incomingRoot && incomingRoot.querySelector(PAGINATION);
        if (!incomingGrid) throw new Error('Collection grid missing');
        if (!root.isConnected) { complete(); return false; }
        var cards = [];
        Array.prototype.forEach.call(incomingGrid.children, function (card) {
          var id = card.dataset.mrdProductId;
          if (id && !seenProducts.has(id)) {
            seenProducts.add(id);
            cards.push(card);
          }
        });
        if (cards.length) {
          var fragment = document.createDocumentFragment();
          cards.forEach(function (card) { fragment.appendChild(card); });
          grid.appendChild(fragment);
          initializeNewCards(cards);
        }
        // Replace only the navigation markup, not the live grid, filters or sorting.
        if (incomingPagination) pagination.innerHTML = incomingPagination.innerHTML;
        nextUrl = findNext(incomingPagination);
        loadedPages += 1;
        if (!nextUrl || requestedUrls.has(nextUrl)) complete();
        return true;
      } catch (error) {
        fallback('Unable to load more products. Use the page links below.');
        return false;
      } finally {
        busy = false;
        setLoading(false);
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!restoring && entries.some(function (entry) { return entry.isIntersecting; })) {
        loadNext();
      }
    }, { rootMargin: '400px 0px', threshold: 0 });

    function saveReturnPosition() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          y: window.scrollY || window.pageYOffset || 0,
          loaded: loadedPages, time: Date.now()
        }));
      } catch (_) {}
    }

    grid.addEventListener('click', function (event) {
      var element = event.target.closest && event.target.closest('a[href]');
      if (!element || !grid.contains(element)) return;
      try {
        var url = new URL(element.href, location.href);
        if (url.origin === location.origin && /\/products\//.test(url.pathname)) {
          productNavigation = true;
          saveReturnPosition();
        }
      } catch (_) {}
    });
    window.addEventListener('pagehide', function () {
      if (productNavigation) saveReturnPosition();
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
      }
    });

    async function restoreReturnPosition() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
      if (!saved || typeof saved.y !== 'number' ||
          Date.now() - saved.time > 1800000 || saved.time > Date.now() + 60000) return;
      restoring = true;
      observer.disconnect();
      var count = Math.min(Math.max(saved.loaded || 0, 0), MAX_RESTORE_PAGES);
      for (var i = 0; i < count && nextUrl && !finished; i++) {
        if (!(await loadNext())) break;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, saved.y);
          restoring = false;
          if (!finished && root.isConnected) observer.observe(sentinel);
          try { sessionStorage.removeItem(storageKey); } catch (_) {}
        });
      });
    }

    observer.observe(sentinel);
    restoreReturnPosition();
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  if (!window.mrdInfiniteSectionListener) {
    window.mrdInfiniteSectionListener = true;
    document.addEventListener('shopify:section:load', boot);
  }
})();